import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Remises panachées par producteur (configurées dans l'admin, onglet Fournisseurs)
export function useDiscounts() {
  const [tiersMap, setTiersMap] = useState({});
  useEffect(() => {
    api.get("/discounts").then((res) => setTiersMap(res.data)).catch(() => {});
  }, []);
  return tiersMap;
}

export function tierRate(tiers, qty) {
  let rate = 0;
  (tiers || []).forEach((t) => {
    if (qty >= t.threshold) rate = t.rate;
  });
  return rate;
}

export function nextTier(tiers, qty) {
  return (tiers || []).find((t) => qty < t.threshold) || null;
}

export function fmtRate(rate) {
  return `−${rate.toFixed(2).replace(".", ",")} €/bt`;
}
